export class SelectOption {
    id: any
    name: string

    constructor(id: any, name: string) {
        this.id = id
        this.name = name
    }
}
